import Vue from "vue";
import { mapState } from "vuex";

import comboComponent from "@/components/child/form/combo.vue";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import "@/components/parent/crud/crud.scss";
import { Component, Prop, Watch } from "@/decorators";
import PaginationModel from "@/models/paginationModel";
import ProdutoEstoqueConferenciaModel, {
    ProdutoEstoqueConferenciaListParameters,
} from "@/models/produtoEstoqueConferenciaModel";
import UsuarioModel from "@/models/usuarioModel";
import grupoProdutoService from "@/services/produto/grupoProdutoService";
import ProdutoEstoqueConferenciaService from "@/services/produtoEstoqueConferenciaService";
import { AppState, SessionActions } from "@/store/store";

@Component({
    components: {
        gridComponent,
        comboComponent,
    },
    computed: {
        ...mapState({
            usuarioLogado: (state: AppState) => state.session.usuarioLogado,
        }),
    },
})
export default class ManipulacaoListComponent extends Vue {
    private service: ProdutoEstoqueConferenciaService = new ProdutoEstoqueConferenciaService();
    private produtosEstoque: Array<ProdutoEstoqueConferenciaModel> = [];
    usuarioLogado: UsuarioModel;

    gridFilterKey = "";
    gridSortKey = "descricao";
    gridSortOrder = "asc";
    gridData: Array<ProdutoEstoqueConferenciaModel> = [];

    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn(
                "descricao",
                this.$t("__.ts.descr") as string,
                GridColumnType.String,
                false,
                false,
                "",
                "",
                true,
            ),
        ];
    }

    subDataName = "produtoLotes";
    get gridColumnsVinculos(): Array<GridColumn> {
        return [
            new GridColumn("descricao", this.$t("__.ts.lote") as string, GridColumnType.String),
            new GridColumn("fornecedorNome", this.$t("__.ts.fornecedor") as string, GridColumnType.String),
            new GridColumn("dataValidade", this.$t("__.ts.dtVal") as string, GridColumnType.String),
        ];
    }
    conditionShowSubData(it) {
        return it["produtoLotes"]["length"] > 0;
    }

    pageIndex = 1;
    pageSize = 9;
    total = 0;

    grupoProdutoFiltro?: number = null;
    grupoProdutoOptions: Array<Object> = [];
    isHidden = false;
    apareceSubGrupo?: number = null;
    subGrupoOptions: Array<Object> = [
        { text: "Ativo", value: 0 },
        { text: "Flavorizante", value: 1 },
        { text: "Veículos/Excipientes", value: 2 },
    ];

    @Prop({ type: Boolean, required: true }) onsemestoque: boolean;
    @Prop({ type: Boolean, required: true }) onestoquebaixo: boolean;
    @Prop({ type: Boolean, required: true }) onestoquevencendo: boolean;

    @Watch("grupoProdutoFiltro")
    private onSub() {
        this.apareceSubGrupo = this.grupoProdutoFiltro;
    }

    filtro: Array<Object> = [];
    subGrupo?: number = null;

    private getFormValues() {
        this.filtro = [];
        if (this.grupoProdutoFiltro != 2) {
            this.subGrupo = null;
        }
        this.filtro.push(this.grupoProdutoFiltro);
        this.filtro.push(this.subGrupo);
        this.pageIndex = 1;
        this.load();
    }

    public async load(resetPagaIndex = false) {
        if (resetPagaIndex) {
            this.pageIndex = 1;
        }

        const customParameters: ProdutoEstoqueConferenciaListParameters = {
            semEstoque: this.onsemestoque,
            vencendo: this.onestoquevencendo,
            estoqueBaixo: this.onestoquebaixo,
            combo: this.filtro[0] != null ? this.filtro[0].toString() : "",
            sub: this.filtro[1] != null ? this.filtro[1].toString() : "",
        };

        const data = await this.service
            .list(this.gridFilterKey, "descricao", "asc", this.pageIndex, this.pageSize, customParameters)
            .withLoading()
            .resolveWithJSON<PaginationModel<ProdutoEstoqueConferenciaModel>>();

        this.produtosEstoque = new Array<ProdutoEstoqueConferenciaModel>();
        this.produtosEstoque = data.list;
        this.total = data.total;
    }

    private onChangeFilterKey(filterKey: string) {
        this.gridFilterKey = filterKey;
        this.load();
    }

    private onChangeSort(sortKey: string, sortOrder: string) {
        this.gridSortKey = sortKey;
        this.gridSortOrder = sortOrder;
        this.load();
    }

    private onChangePage(pageIndex: number) {
        this.pageIndex = pageIndex;
        this.load();
    }

    private async mounted() {
        await this.$store.dispatch(SessionActions.LOAD_USUARIO_LOGADO);

        const response = await Promise.all([
            grupoProdutoService.comboCached(this.usuarioLogado.franquiaId),
            this.load(), //buscar orcamentos e totais
        ]).withLoading();

        this.grupoProdutoOptions = response[0];
    }
}
